export default __webpack_public_path__ + "static/media/property_655.ca700a19.png";